const state = {
  confirm: null,
  loading: false,
  showAnimation: false
}

const getters = {
  getLoading: state => state.loading,
  getShowAnimation: state => state.showAnimation
}

const mutations = {
  setConfirm (state, value) {
    state.confirm = value
  },
  setLoading (state, value) {
    state.loading = value
  },
  setShowAnimation (state, value) {
    state.showAnimation = value
  }
}

const actions = {
}

export default { namespaced: true, state, mutations, actions, getters }
